import JPManShirt from './JPManShirt'
import ManShirt from './ManShirt'
import JPWomanShirt from './JPWomanShirt'
import WomanShirt from './WomanShirt'
import ManPolo from './ManPolo'
import ManPolo2 from './ManPolo2'
import ManPolo3 from './ManPolo3'
import ManPolo4 from './ManPolo4'
import WomanPolo from './WomanPolo'
import ManTShirt from './ManTShirt'
import WomanTShirt from './WomanTShirt'
import ManSuit from './ManSuit'
import WomanSuit from './WomanSuit'
import ManSuitTrousers from './ManSuitTrousers'
import WomanSuitTrousers from './WomanSuitTrousers'
import ManJacket from './ManJacket'
import WomanJacket from './WomanJacket'
import JPWomanHipSkirt from './JPWomanHipSkirt'
import JPManVest from './ManVest'
import JPManCasualTrosusers from './ManCasualTrousers'
import Zero from './Zero'

let manager = {};


manager['XMJ-BCE-10406'] = manager['MTM-MZ001'] = manager['MTM-MZ016'] = function() {
    return new ManSuit()
}
manager['MTM-WZ007'] = manager['HLT266'] = manager['MTM-WZ020'] = function() {
    return new WomanSuit()
}
manager['MTM-MC003'] = manager['XKC21047'] = function() {
    return new JPManShirt()
}
manager['MTM-MC023'] = manager['MTM-MC035'] = manager['MTM-MC069'] = function() {
    return new JPManShirt()
}
manager['MTM-WC009'] = manager['XKC21048'] = function() {
    return new WomanShirt()
}
manager['MTM-WC024'] = manager['MTM-WC025'] = function() {
    return new JPWomanShirt()
}
manager['MTM-MP012'] = manager['MTM-MP013'] = function() {
    return new ManPolo()
}
manager['MTM-MP014'] = function() {
    return new ManPolo4()
}
manager['MTM-MP004'] = manager['MTM-MP030'] = function() {
    return new ManPolo2()
}
manager['MTM-MP036'] = function() {
    return new ManPolo3()
}
manager['MTM-WP010'] = manager['WP5SS'] = function() {
    return new WomanPolo()
}
manager['MTM-MT005'] = manager['MTM-MT029'] = manager['MTM-MC070'] = manager['MTM-MC071'] = manager['MTM-MC072'] = manager['MTM-MC073'] = manager['MTM-MC074'] = manager['MTM-MC075'] = manager['MTM-MC076'] = function() {
    return new ManTShirt()
}
manager['MTM-WT011'] = manager['HLT946'] = function() {
    return new WomanTShirt()
}
manager['MTM-WQ018'] = function() {
    return new JPWomanHipSkirt()
}
manager['MTM-MK002'] = manager['XMK-RC150B-ST'] = manager['MTM-MK015'] = manager['HMK1987'] = function() {
    return new ManSuitTrousers()
}
manager['MTM-WK008'] = manager['XMK-RC150B-STW'] = manager['MTM-WK021'] = function() {
    return new WomanSuitTrousers()
}
manager['MTM-MK031'] = function() {
    return new JPManCasualTrosusers()
}
manager['MTM-MJ032'] = function() {
    return new JPManVest()
}
manager['MTM-MJ033'] = manager['HMJ883'] = manager['MTM-MJ063'] = manager['MTM-MJ064'] = manager['MTM-MJ065'] = manager['MTM-MJ066'] = manager['MTM-MJ067'] = function() {
    return new ManJacket()
}
manager['MTM-WJ034'] = function() {
    return new WomanJacket()
}
manager.factory = function(style) {
    if(!(style in manager)) {
        return new Zero
    }
    return new manager[style];
}
export default manager


